<template>
	<div>
		<h6 class="ts-text-white ts-uppercase ts-bg-blue-500 ts-px-2 ts-py-1 ts-rounded-md" style="width:fit-content">
			{{ $t('promotion.modules') }}
		</h6>
		<div class="ts-pl-4">
			<ts-checkbox v-for="(b, index) in modules" :key="index" v-model="model.modules" :value="b.value">{{
				b.label }}</ts-checkbox>
		</div>
	</div>
</template>

<script>
export default {
	name: 'modules',
	props: ['value'],
	data() {
		return {
			model: {}
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		modules() {
			return [
				{ value: 'wholesale', label: 'Whole Sale' },
				{ value: 'retailsale', label: 'Retail Sale' },
				{ value: 'borrowing', label: 'Borrowing' }
			]
		}
	}
}
</script>